// tslint:disable:max-line-length
import * as React from 'react';

export const place = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="16" viewBox="0 0 12 16">
    <path fillRule="evenodd" d="M1.171 7.985l4.524 7.819c.15.259.39.264.544 0l4.524-7.819.066-.13a5.265 5.265 0 0 0 .671-2.452c0-2.238-1.405-4.245-3.533-5.045a5.567 5.567 0 0 0-6.06 1.436 5.328 5.328 0 0 0-.802 6.072l.066.12zM6 3.025c1 0 1.902.595 2.28 1.505a2.39 2.39 0 0 1-.554 2.643 2.497 2.497 0 0 1-2.7.496 2.419 2.419 0 0 1-1.49-2.266C3.56 4.083 4.656 3.025 6 3.026z" opacity=".9"/>
  </svg>
);

// tslint:enable:max-line-length
